import { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, FormGroup, Input, Button, Form,
} from 'reactstrap';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

class FirmasDocumentosListFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formFilters: {
        PLATE: '',
        TYPE: '',
        REPERTORY: '',
        STATUS: '',
        DATE_FROM: '',
        DATE_TO: '',
        DATE_RANGE: '',
        PREADMISSION: '',
        PREADMISSION_DATE_START: '',
        PREADMISSION_DATE_END: '',
        WITH_OUT_REQUEST_UP: '',
      },
      activeTab: '',
      defaultFilters: props.defaultFilters,
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.setFilters = this.setFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.onDateRangeSelected = this.onDateRangeSelected.bind(this);
    this.onDatePreadmissionRangeSelected = this.onDatePreadmissionRangeSelected.bind(this);
    this.renderDateComponent = this.renderDateComponent.bind(this);
  }

  componentWillReceiveProps(props) {
    this.setState({ defaultFilters: props.defaultFilters, activeTab: props.activeTab });
  }

  handleFilterChange(event) {
    console.log(event);
    let newFilterData = {};
    newFilterData[event.target.id] = event.target.value;
    newFilterData = Object.assign(this.state.formFilters, newFilterData);
    this.setState({ formFilters: newFilterData });
  }

  setFilters() {
    const filters = {};
    for (const filter in this.state.formFilters) {
      if (Object.prototype.hasOwnProperty.call(this.state.formFilters, filter) && this.state.formFilters[filter]) {
        filters[filter] = this.state.formFilters[filter];
      }
    }
    this.props.setFiltersCallback(filters);
  }

  resetFilters() {
    const filters = {
      PLATE: '',
      TYPE: '',
      REPERTORY: '',
      STATUS: '',
      DATE_FROM: '',
      DATE_TO: '',
      PREADMISSION_DATE_RANGE: '',
      PREADMISSION_DATE_START: '',
      PREADMISSION_DATE_END: '',
      DATE_RANGE: '',
      PREADMISSION: '',
      WITH_OUT_REQUEST_UP: '',
    };
    this.setState({ formFilters: filters });
  }

  renderDateComponent(label, id, onChangeFunction) {
    return (
      <DateRangePicker
        onApply={onChangeFunction}
        ranges={
                                    {
                                      Hoy: [moment(), moment()],
                                      Ayer: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                      'Esta semana': [moment().startOf('week'), moment().endOf('week')],
                                      'Última semana': [moment().subtract(6, 'days'), moment()],
                                      'Últimas 2 semanas': [moment().subtract(13, 'days'), moment()],
                                      'Este mes': [moment().startOf('month'), moment().endOf('month')],
                                      'Mes anterior': [moment().subtract(1, 'month').startOf('month'),
                                        moment().subtract(1, 'month').endOf('month')],
                                    }
                                }
        locale={{
          format: 'DD/MM/YYYY',
          applyLabel: 'Aplicar',
          cancelLabel: 'Limpiar',
          fromLabel: 'Desde',
          toLabel: 'Hasta',
          customRangeLabel: 'Seleccionar rango',
          daysOfWeek: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
          monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre',
            'Diciembre'],
          firstDay: 1,
        }}
        containerStyles={{ display: 'block' }}
      >
        <Input
          type="text"
          placeholder={label}
          id={id}
          className="form-control-sm"
          onChange={this.handleFilterChange}
          value={this.state.formFilters[id] || this.state.defaultFilters[id]}
        />
      </DateRangePicker>
    );
  }

  onDateRangeSelected(event, picker) {
    const filterChangeEvent = {
      target: {
        id: 'DATE_RANGE',
        value: `${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`,
      },
    };
    this.handleFilterChange(filterChangeEvent);

    filterChangeEvent.target.id = 'DATE_FROM';
    filterChangeEvent.target.value = picker.startDate.format('YYYY-MM-DD');
    this.handleFilterChange(filterChangeEvent);

    filterChangeEvent.target.id = 'DATE_TO';
    filterChangeEvent.target.value = picker.endDate.format('YYYY-MM-DD');
    this.handleFilterChange(filterChangeEvent);
  }

  onDatePreadmissionRangeSelected(event, picker) {
    const filterChangeEvent = {
      target: {
        id: 'PREADMISSION_DATE_RANGE',
        value: `${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`,
      },
    };
    this.handleFilterChange(filterChangeEvent);

    filterChangeEvent.target.id = 'PREADMISSION_DATE_START';
    filterChangeEvent.target.value = picker.startDate.format('YYYY-MM-DD');
    this.handleFilterChange(filterChangeEvent);

    filterChangeEvent.target.id = 'PREADMISSION_DATE_END';
    filterChangeEvent.target.value = picker.endDate.format('YYYY-MM-DD');
    this.handleFilterChange(filterChangeEvent);
  }

  render() {
    return (
      <Form className="px-2">
        <Row>
          {['signed', 'full'].indexOf(this.state.activeTab) !== -1
            ? (
              <Col md={3}>
                <FormGroup>
                  {this.renderDateComponent('Fecha firma documento', 'DATE_RANGE', this.onDateRangeSelected)}
                </FormGroup>
              </Col>
            )
            : ''}

          <Col md={3}>
            <FormGroup>
              <Input
                type="text"
                placeholder="Patente"
                id="PLATE"
                className="form-control-sm"
                onChange={this.handleFilterChange}
                value={this.state.formFilters.PLATE}
              />
            </FormGroup>
          </Col>

          <Col md={3}>
            <Button
              className="btn btn-sm btn-primary-darker btn-filter"
              onClick={this.setFilters}
            >
              Aplicar
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

FirmasDocumentosListFilter.propTypes = {
  defaultFilters: PropTypes.object,
  activeTab: PropTypes.string,
  setFiltersCallback: PropTypes.func,
};

export default FirmasDocumentosListFilter;
